import { router, usePage } from "@inertiajs/react"
import { useEffect, useRef } from "react"
import { toast } from "sonner"

import type { Flash } from "@/types"

export const useFlash = () => {
  const { flash } = usePage().props as { flash: Flash }
  const initialFlashHandled = useRef(false)
  const flashAlert = flash?.alert
  const flashNotice = flash?.notice

  // Handle flash from the initial page load (e.g. after a server-side redirect)
  useEffect(() => {
    if (initialFlashHandled.current) return
    initialFlashHandled.current = true

    if (flashAlert) {
      toast.error(flashAlert)
    }
    if (flashNotice) {
      toast(flashNotice)
    }
  }, [flashAlert, flashNotice])

  // Handle flash from subsequent Inertia visits
  useEffect(() => {
    return router.on("beforeUpdate", (event) => {
      const updatedFlash = event.detail.page.props.flash as Flash
      if (updatedFlash.alert) {
        toast.error(updatedFlash.alert)
      }
      if (updatedFlash.notice) {
        toast(updatedFlash.notice)
      }
      event.detail.page.props.flash = {}
    })
  }, [])
}
